/* Product-card image carousel: thumbnail strip + arrows. Delegated, so one listener serves every card
   (including cards injected later by filters / pagination). */
(function () {
  if (window.__cavCardGallery) return;
  window.__cavCardGallery = true;

  function setActive(gallery, index) {
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('.card-gallery__thumb'));
    if (!thumbs.length) return;
    index = (index + thumbs.length) % thumbs.length;
    thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === index); });
    var thumb = thumbs[index];
    var inner = gallery.closest('.card__inner');
    var img = inner && inner.querySelector('.card__media .media img');
    if (img) {
      img.removeAttribute('srcset');
      img.src = thumb.getAttribute('data-src');
      img.alt = thumb.getAttribute('data-alt') || '';
    }
    var strip = gallery.querySelector('.card-gallery__strip');
    if (strip) strip.scrollTo({ left: thumb.offsetLeft - strip.clientWidth / 2 + thumb.clientWidth / 2, behavior: 'smooth' });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.card-gallery__thumb, .card-gallery__arrow');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var gallery = btn.closest('.card-gallery');
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('.card-gallery__thumb'));
    var current = thumbs.findIndex(function (t) { return t.classList.contains('is-active'); });
    if (btn.classList.contains('card-gallery__thumb')) setActive(gallery, thumbs.indexOf(btn));
    else setActive(gallery, current + (btn.getAttribute('data-dir') === 'next' ? 1 : -1));
  }, true);
})();
